// extracted by mini-css-extract-plugin
export var dropdownButton = "_3z-0";
export var fullWidthDropdownButton = "_3z-1";
export var icon = "_3z-3";
export var iconPlaceholder = "_3z-2";
export var menuItemRow = "_3z-9";
export var separator = "_3z-e";
export var shortcutContainer = "_3z-7";
export var shortcutContainerFilled = "_3z-8";
export var shortcutIconLg = "_3z-6";
export var shortcutIconMd = "_3z-5";
export var shortcutIconSm = "_3z-4";
export var submenuChevron = "_3z-d";
export var submenuDropdown = "_3z-a";
export var submenuTriggerRow = "_3z-b";
export var submenuTriggerRowOpen = "_3z-c";